<template>
  <feature-toggle :toggle="enableLinePricingGroupImport">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <tooltip :value="$t('actions.uploadLinePricing.main')" position="bottom">
          <v-btn
            small
            color="primary"
            class="ml-2"
            :loading="busyImportingLinePricingGroups"
            :disabled="disabled"
            depressed
            v-on="on"
          >
            <v-icon small left>$import</v-icon>
            {{ $t('actions.upload') }}
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </tooltip>
      </template>

      <v-list>
        <v-list-item
          v-if="isPricingManager || isPricingSpecialist"
          @click="importLinePricingHandler({ importAG: false })"
        >
          <v-list-item-title>
            {{ $t('actions.uploadLinePricing.workpackage') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="importLinePricingHandler({ importAG: true })">
          <v-list-item-title>
            {{ $t('actions.uploadLinePricing.ag') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </feature-toggle>
</template>

<script>
import featureFlagsMixin from '../mixins/featureFlags';
import { mapState, mapGetters } from 'vuex';
import { enableLinePricingGroupImport } from '@enums/feature-flags';

export default {
  name: 'LinePricingImportButton',
  mixins: [featureFlagsMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enableLinePricingGroupImport,
    };
  },
  computed: {
    ...mapState('architectureGroup', ['busyImportingLinePricingGroups']),
    ...mapGetters('context', ['isPricingManager', 'isPricingSpecialist']),
  },
  methods: {
    importLinePricingHandler({ importAG }) {
      this.$emit('click', { importAG });
    },
  },
};
</script>
